/**
 * Componente que exibe "caixa de diálogo" como modal na página.
 *
 * Implementado usando um elemento "modal" único no página que é reutilizado a cada
 * mensagem.
 */

// Armazena a instância de componente montada na página.
let store = {
  dialog: undefined
};

import moment from 'moment';

export default {

  data() {
    return {
      title: undefined,
      message: undefined,
      type: undefined,
      headerClass: undefined,
      resultCallback: undefined,
      contract:undefined,
      startDate:undefined,
      endDate:undefined,
      filter:undefined,
      transactions:undefined,
      urlBlank: undefined,
      txtBlank: undefined,
      colorTxtBlank: undefined,
      showContactText: undefined
    }
  },

  mounted() {
    // Ao montar, atribui a instancia de componente ao "store"
    store.dialog = this;
  },
  methods: {
    result(res) {
      // retorna o resultado e fecha o modal.
      $(this.$el).modal('hide');
      this.resultCallback(res);
    },
     close(){
      $('#messageDialog').modal('hide');
    },
    generateFileName(ext,start,end){
      let startString = moment(start).format('DD-MM-YYYY');
      let endString = moment(end).format('DD-MM-YYYY');
      return `extrato_${startString}_a_${endString}.${ext}`;
    }
  },

  /**
   * Método estático para abrir o modal.
   *
   * Os tipos suportados são:
   *  'OK'
   *  'OK-CANCEL'
   *  'YES-NO'
   *  'DOWNLOAD'
   *
   * Retorna uma Promisse com o resultado.
   *
   * @param options objeto com a configuração do modal
   * @param options.title Título
   * @param options.message Mensagem (pode ser HTML)
   * @param options.type Tipo do modal.
   * @param options.headerClass a classe no header do modal. padrão: 'modal-info'
   **/

   computed: {
     urlExcel(){
       let file = this.generateFileName('xls',store.dialog.startDate,store.dialog.endDate);
       // let url = `/api/v2/statement/excel/${ store.dialog.contract}/${ store.dialog.startDate}/${ store.dialog.endDate}/${file}`;
       let url = `/api/v2/statement/excel/${ store.dialog.contract}/${ store.dialog.startDate}/${ store.dialog.endDate}/${file}`;
       url = (!store.dialog.filter) ? url : url + `/${ store.dialog.filter}`;
       url = (store.dialog.transactions) ?`${url}?transactions=${store.dialog.transactions}` : url;
       return {url,file};
     },
     urlPdf(){
       let file = this.generateFileName('pdf',store.dialog.startDate,store.dialog.endDate);
       let url = `/api/v2/statement/pdf/${ store.dialog.contract}/${ store.dialog.startDate}/${ store.dialog.endDate}/${file}`;
       // let url = `/api/v1/statement/pdf/${ store.dialog.contract}/${ store.dialog.startDate}/${ store.dialog.endDate}/${file}`;
       url = (!store.dialog.filter) ? url : url + `/${ store.dialog.filter}`;
       url = (store.dialog.transactions) ?`${url}?transactions=${store.dialog.transactions}` : url;
       return {url,file};
     },
     urlJson(){
       let file = this.generateFileName('zip',store.dialog.startDate,store.dialog.endDate);
       let url = `/api/v2/statement/json/${ store.dialog.contract}/${ store.dialog.startDate}/${ store.dialog.endDate}/${file}`;
       // let url = `/api/v1/statement/json/${ store.dialog.contract}/${ store.dialog.startDate}/${ store.dialog.endDate}/${file}`;
       url = (!store.dialog.filter) ? url : url + `/${ store.dialog.filter}`;
       url = (store.dialog.transactions) ?`${url}?transactions=${store.dialog.transactions}` : url;
       return {url,file};
     }
   },
  show(options) {

    if(options.statement){
      store.dialog.contract = options.statement.contract;
      store.dialog.startDate = options.statement.startDate;
      store.dialog.endDate = options.statement.endDate;
      store.dialog.filter = options.statement.filter;
      store.dialog.transactions = options.statement.transactions;
    }

    return new Promise((resolve, reject) => {
      store.dialog.title = options.title || '';
      store.dialog.headerClass = options.headerClass || 'modal-info';
      store.dialog.message = options.message || '';
      store.dialog.type = options.type || 'OK';
      store.dialog.txtBlank = options.txtBlank || '';
      store.dialog.urlBlank = options.urlBlank || '';
      store.dialog.colorTxtBlank = options.colorTxtBlank || '#000000';
      store.dialog.showContactText = options.showContactText;
      store.dialog.resultCallback = resolve;
      $(store.dialog.$el).modal('show');
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/message-dialog.js